import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { isQAOverrideUser } from "@/lib/qaOverride";

/**
 * Returns whether the current authenticated user is a designated QA admin
 * who can replay/preview modules without affecting learner data. Resolved
 * server-side via the `is_qa_override_user` RPC.
 */
export function useQAOverride() {
  const { user } = useAuth();
  const [isQAOverride, setIsQAOverride] = useState(false);
  useEffect(() => {
    let cancelled = false;
    if (!user?.id) {
      setIsQAOverride(false);
      return;
    }
    void isQAOverrideUser(user.id).then((v) => {
      if (!cancelled) setIsQAOverride(v);
    });
    return () => {
      cancelled = true;
    };
  }, [user?.id]);
  return { isQAOverride };
}